import axios from 'axios';
import { API_URL } from '../../config/URL/URL';

/**
 * 로그 데이터를 서버에 전송하는 함수
 * @param {Object} params - 로그 파라미터
 * @param {string} params.page - 페이지 경로
 * @param {string} params.eventName - 이벤트 이름
 * @param {any} params.eventValue - 이벤트 값
 * @param {string} params.sessionToken - 세션 토큰
 * @param {Object} [params.properties] - 추가 속성
 * @returns {Promise<string|null>} 새로운 토큰 또는 null
 */
export const createLog = async ({ page, eventName, eventValue, sessionToken, properties }) => {
    if (!sessionToken) {
        console.warn('세션 토큰이 없어 로그를 생성할 수 없습니다.');
        return null;
    }

    const data = {
        page,
        eventName,
        eventValue,
        properties: properties ? JSON.stringify(properties) : null,
    };

    const options = {
        headers: {
            sessionToken,
            'Content-Type': 'application/json',
        },
    };

    try {
        const response = await axios.post(`${API_URL}/log/create`, JSON.stringify(data), options);
        const token = `Bearer ${response.data}`;
        return token;
    } catch (error) {
        console.error('로그 생성 중 오류 발생:', error);
        return null;
    }
};
